import React from 'react'
import { Card } from "react-bootstrap"
import { Text } from "@fluentui/react";
//import "office-ui-fabric-react/dist/css/fabric.css";
import '../../../../styles/css/Card.css';

function StadisticCard(props) {

    //Parametros de entrada.
    const inputParam_Item = props.item !== null && props.item !== undefined ? props.item : null;
    const inputParam_SetSelectedStadisticCard = props.setSelectedStadisticCard !== null && props.setSelectedStadisticCard !== undefined ? props.setSelectedStadisticCard : null;
    const inputParam_SelectedItem = props.selectedStadisticCard !== null && props.selectedStadisticCard !== undefined ? props.selectedStadisticCard : null;
    const inputParam_SetFireOrderData = props.setFireOrderData !== null && props.setFireOrderData !== undefined ? props.setFireOrderData : null;
    const inputParam_SetObjHomeStadisticData = props.setObjHomeStadisticData !== null && props.setObjHomeStadisticData !== undefined ? props.setObjHomeStadisticData : null;
    
    const icon = {
        fontSize: 24,
        verticalAlign: "middle",
        color: "#0078d4"
      };
    const styles = {
        header: {
            root: {
                fontSize: 12,
                fontWeight: "bold",
                padding: "10px"
            }
        },
        amount: {
            root: {
                fontSize: "30px",
                verticalAlign: "middle",
            }
        }
    };
    const onStadisticCardSelected = () => {
        if (inputParam_SelectedItem !== null) {
            if (inputParam_SelectedItem.type === inputParam_Item.type) {
                inputParam_SetSelectedStadisticCard && inputParam_SetSelectedStadisticCard(null)
                inputParam_SetFireOrderData && inputParam_SetFireOrderData(false)

                inputParam_SetObjHomeStadisticData && inputParam_SetObjHomeStadisticData(prevState => ({
                    ...prevState,
                    data: null,
                    fireUpdate: true
                }));
            }
            else {
                inputParam_SetSelectedStadisticCard && inputParam_SetSelectedStadisticCard(inputParam_Item)
                inputParam_SetFireOrderData && inputParam_SetFireOrderData(true)
            }
        }
        else {
            inputParam_SetSelectedStadisticCard && inputParam_SetSelectedStadisticCard(inputParam_Item)
            inputParam_SetFireOrderData && inputParam_SetFireOrderData(true)
        }
    }
    return (
            <div onClick={ onStadisticCardSelected } style={{display: inputParam_Item.display ? "block" : "none"}} className="row mx-2">
                <Card className={ inputParam_SelectedItem && inputParam_SelectedItem.type === inputParam_Item.type ? "selected-stadistic-card" : ""} style={{paddingLeft: "5px", paddingRight: "5px", borderTop: inputParam_Item.borderTop}}>
                    <div className="text-center">
                        <i style={ icon } className={ `ms-Icon ms-Icon--${inputParam_Item.icon}` } ></i>
                        <Text className="fw-bold ps-2" styles={styles.amount}>{inputParam_Item.amount}</Text>
                    </div>
                    <div style={{fontSize: "small", whiteSpace : "nowrap"}} className="text-center">
                        {inputParam_Item.title}
                    </div>
                </Card>
            </div>
    );
}

export default StadisticCard;